// CaregiversEngageSection.js
import React from "react";
import caregiversEngageImage from "../assets/caregivers-engage-image.jpg";

const CaregiversEngageSection = () => {
  return (
    <section className="relative bg-white overflow-hidden">
      {/* Top curved section with gradient */}
      <div
        className="relative"
        style={{
          background: "linear-gradient(90deg, #AD2647 0%, #E85D2C 100%)",
          clipPath: "ellipse(150% 100% at 50% 0%)",
          paddingBottom: "120px",
        }}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 pt-16 pb-8">
          <div className="max-w-3xl">
            <p className="text-white text-sm font-light tracking-wider mb-3 uppercase">
              ALLAWAH HOME CARE
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
              Proudly Caring for Coolamon's Seniors — One Home at a Time
            </h2>
            <p className="text-white text-sm md:text-base font-light leading-relaxed">
              At Allawah Compassionate Home Care, we believe every senior
              deserves to feel valued, respected, and supported in the place
              they call home. Our caregivers provide personalised care that
              promotes safety, independence, and companionship—helping families
              across Coolamon and beyond find peace of mind and loved ones live
              life to the fullest.
            </p>
          </div>
        </div>
      </div>

      {/* Bottom section with image and content */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div>
            <img
              src={caregiversEngageImage}
              alt="Caregiver with elderly woman using tablet"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>

          {/* Right Content */}
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 leading-tight">
              Our Caregivers Engage Seniors in Their Day To Day Activities
            </h3>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-6">
              <p>
                We take great care in matching each client with a caregiver who
                not only has the right skills but also a compatible personality.
                A strong, trusting relationship is the foundation of quality
                companion care, and we are committed to finding the perfect fit
                for your family. Our goal is to provide a companion who feels
                like a natural extension of your family.
              </p>

              <p>
                To put your mind at ease, Allawah Lodge is a fully licensed and
                insured provider, and all of our caregivers are thoroughly
                screened beforehand. We will carefully match your loved one up
                with a friendly companion that's uniquely qualified for their
                personality and interests who will engage them in healthy
                activities such as:
              </p>
            </div>

            <ul className="space-y-2 text-gray-700 font-light">
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>Meal preparation with a focus on nutrition</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>
                  Crafts, scrapbooking, and playing games for mental stimulation
                </span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>
                  Going on outings together to encourage human interaction
                </span>
              </li>
              <li className="flex items-start">
                <span className="mr-2">•</span>
                <span>
                  Discussing life experiences while reminiscing about past event
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaregiversEngageSection;
